









import { Component, Prop, Vue } from "vue-property-decorator";
import AsyncButton from "@components/form/async-button.vue";

@Component({ components: { AsyncButton }})
export default class InvestButton extends Vue {
	isWorking = false;

	@Prop({ default: '' })
	classes!: string;

	@Prop({ default: false })
	divider!: boolean;

	async handleClick(): Promise<void> {
		if (this.$route.name === 'account-invest') {
			return;
		} 

		this.isWorking = true;
		await this.$router.push({ name: 'account-invest'});
	}
}
